import React from 'react';
import { Image as LucideImage } from 'lucide-react';

interface ImageProps {
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}

const ImageIcon: React.FC<ImageProps> = ({ width = 24, height = 24, className, style }) => (
  <LucideImage width={width} height={height} className={className} style={style} aria-hidden strokeWidth={2} />
);

export default ImageIcon;
